import React, { useState, useEffect } from 'react';
import CompassArrow from 'assets/images/compass_arrow.svg';

const Compass = (props) => {

    const [rotation, setRotation] = useState(0);
    const [direction, setDirection] = useState('Nord');

    const moveCompassToPoint = (e) => {
        // const rect = e.target.getBoundingClientRect();
        // const x = rect.left - window.scrollX + (rect.width / 2);
        // const y = rect.top - window.scrollY + (rect.height / 2);        
        const rect = e.currentTarget.getBoundingClientRect();
        const x = rect.left + rect.width / 2;
        const y = rect.top + rect.height / 2;

        if(e.clientX && e.clientY){
            const angle1 = getAngle({
                x: e.clientX - x,
                y: y - e.clientY,
            });

            const angle2 = nearestCardinalPoint(Math.floor(-Math.abs(angle1))+90);
            setRotation(angle2);
            const label = setLabel(angle2);

            if(props.onClick){
                props.onClick(props, label);
            }
        }
    }

    const setLabel = (angle) => {
        const direction = getDirectionLabel(angle);
        setDirection(direction);
        return direction;
    }

    const getDirectionLabel = (angle) => {        
        const directions = {
            0: 'Nord', 360: 'Nord',
            45: 'Nordost', 90: 'Ost',
            135: 'Südost', 180: 'Süd',
            225: 'Südwest', 270: 'West',
            315: 'Nordwest'
        }

        return directions[angle];
    }

    const getDirectionAngle = (direction) => {
        const directionLabels = {
            'Nord': 360,
            'Nordost': 45, 'Ost': 90,
            'Südost': 135, 'Süd': 180,
            'Südwest': 225, 'West': 270,
            'Nordwest': 315
        }

        return directionLabels[direction];
    }

    // useEffect(() => {
    //     if(props.defaultDirection){
    //         setRotation(getDirectionAngle(props.defaultDirection));
    //     }
    // }, [props.defaultDirection]);

    // useEffect(()=>{
    //     setDirection(props.defaultDirection)
    // }, [props.defaultDirection])

    useEffect(() => {
        if (props.defaultDirection) {
            const angle = getDirectionAngle(props.defaultDirection);
            setRotation(angle);
            setDirection(props.defaultDirection);
        }
    }, [props.defaultDirection]);

    function getAngle(point) {
        if (point.x < 0 && point.y > 0) {
          return 180 + (Math.atan(point.y / point.x) * 180 / Math.PI);
        }
        if (point.x > 0 && point.y < 0) {
          return 360 + (Math.atan(point.y / point.x) * 180 / Math.PI);
        }
        if (point.x < 0 && point.y < 0) {
          return 180 + (Math.atan(point.y / point.x) * 180 / Math.PI);
        }
        return Math.atan(point.y / point.x) * 180 / Math.PI;
    }
   
    function nearestCardinalPoint(angle) {
        // Normalize angle to be within 0 to 360 degrees
        angle = angle % 360;
        if (angle < 0) {
            angle += 360;
        }

        // Calculate the nearest multiple of 45 degrees
        var nearest = Math.round(angle / 45) * 45;
        return nearest;
    }

    return (
        <div className={`Compass ${props.className}`}>
            <svg width="123" height="123" viewBox="0 0 123 123" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="62.5" cy="61.5" r="32.5" fill="white" fillOpacity="0.1"/>
            <path d="M58.923 6.718H60.639L64.877 13.556H64.903V6.718H66.45V16H64.734L60.509 9.175H60.47V16H58.923V6.718Z" fill="#D1D7E8"/>
            <path d="M112.94 58.823C112.446 58.823 112.017 58.9227 111.653 59.122C111.298 59.3213 111.007 59.59 110.782 59.928C110.557 60.2573 110.388 60.6343 110.275 61.059C110.171 61.4837 110.119 61.917 110.119 62.359C110.119 62.801 110.171 63.2343 110.275 63.659C110.388 64.0837 110.557 64.465 110.782 64.803C111.007 65.1323 111.298 65.3967 111.653 65.596C112.017 65.7953 112.446 65.895 112.94 65.895C113.434 65.895 113.859 65.7953 114.214 65.596C114.578 65.3967 114.873 65.1323 115.098 64.803C115.323 64.465 115.488 64.0837 115.592 63.659C115.705 63.2343 115.761 62.801 115.761 62.359C115.761 61.917 115.705 61.4837 115.592 61.059C115.488 60.6343 115.323 60.2573 115.098 59.928C114.873 59.59 114.578 59.3213 114.214 59.122C113.859 58.9227 113.434 58.823 112.94 58.823ZM112.94 57.497C113.633 57.497 114.253 57.627 114.799 57.887C115.354 58.147 115.822 58.498 116.203 58.94C116.584 59.382 116.875 59.8977 117.074 60.487C117.282 61.0763 117.386 61.7003 117.386 62.359C117.386 63.0263 117.282 63.6547 117.074 64.244C116.875 64.8333 116.584 65.349 116.203 65.791C115.822 66.233 115.354 66.584 114.799 66.844C114.253 67.0953 113.633 67.221 112.94 67.221C112.247 67.221 111.623 67.0953 111.068 66.844C110.522 66.584 110.058 66.233 109.677 65.791C109.296 65.349 109.001 64.8333 108.793 64.244C108.594 63.6547 108.494 63.0263 108.494 62.359C108.494 61.7003 108.594 61.0763 108.793 60.487C109.001 59.8977 109.296 59.382 109.677 58.94C110.058 58.498 110.522 58.147 111.068 57.887C111.623 57.627 112.247 57.497 112.94 57.497Z" fill="#D1D7E8"/>
            <path d="M61.054 113.906C61.054 114.261 61.1147 114.565 61.236 114.816C61.3573 115.067 61.5263 115.275 61.743 115.44C61.9597 115.596 62.2067 115.713 62.484 115.791C62.77 115.86 63.0777 115.895 63.407 115.895C63.7623 115.895 64.0657 115.856 64.317 115.778C64.5683 115.691 64.772 115.583 64.928 115.453C65.084 115.323 65.1967 115.176 65.266 115.011C65.3353 114.838 65.37 114.664 65.37 114.491C65.37 114.136 65.2877 113.876 65.123 113.711C64.967 113.538 64.7937 113.416 64.603 113.347C64.2737 113.226 63.888 113.113 63.446 113.009C63.0127 112.896 62.4753 112.753 61.834 112.58C61.4353 112.476 61.1017 112.342 60.833 112.177C60.573 112.004 60.365 111.813 60.209 111.605C60.053 111.397 59.9403 111.176 59.871 110.942C59.8103 110.708 59.78 110.47 59.78 110.227C59.78 109.759 59.8753 109.356 60.066 109.018C60.2653 108.671 60.5253 108.385 60.846 108.16C61.1667 107.935 61.5307 107.77 61.938 107.666C62.3453 107.553 62.757 107.497 63.173 107.497C63.6583 107.497 64.1133 107.562 64.538 107.692C64.9713 107.813 65.3483 108 65.669 108.251C65.9983 108.502 66.2583 108.814 66.449 109.187C66.6397 109.551 66.735 109.976 66.735 110.461H65.11C65.0667 109.863 64.863 109.443 64.499 109.2C64.135 108.949 63.6713 108.823 63.108 108.823C62.9173 108.823 62.7223 108.845 62.523 108.888C62.3237 108.923 62.1417 108.988 61.977 109.083C61.8123 109.17 61.6737 109.291 61.561 109.447C61.457 109.603 61.405 109.798 61.405 110.032C61.405 110.361 61.5047 110.621 61.704 110.812C61.912 110.994 62.1807 111.133 62.51 111.228C62.5447 111.237 62.679 111.276 62.913 111.345C63.1557 111.406 63.4243 111.475 63.719 111.553C64.0137 111.631 64.2997 111.709 64.577 111.787C64.863 111.856 65.0667 111.908 65.188 111.943C65.4913 112.038 65.7557 112.168 65.981 112.333C66.2063 112.498 66.3927 112.688 66.54 112.905C66.696 113.113 66.8087 113.338 66.878 113.581C66.956 113.824 66.995 114.066 66.995 114.309C66.995 114.829 66.8867 115.275 66.67 115.648C66.462 116.012 66.1847 116.311 65.838 116.545C65.4913 116.779 65.097 116.948 64.655 117.052C64.213 117.165 63.7623 117.221 63.303 117.221C62.7743 117.221 62.276 117.156 61.808 117.026C61.34 116.896 60.9327 116.697 60.586 116.428C60.2393 116.159 59.962 115.817 59.754 115.401C59.546 114.976 59.4377 114.478 59.429 113.906H61.054Z" fill="#D1D7E8"/>
            <path d="M5.078 57.718H6.729L8.406 64.816H8.432L10.304 57.718H11.968L13.788 64.816H13.814L15.543 57.718H17.194L14.633 67H12.982L11.123 59.902H11.097L9.199 67H7.522L5.078 57.718Z" fill="#D1D7E8"/>
            <circle cx="101" cy="62" r="3" fill="#626B84"/>
            <circle cx="62.5" cy="61.5" r="24.5" fill="#5CC244"/>
            <circle cx="90" cy="35" r="2" fill="#4A5164"/>
            <circle cx="90" cy="88" r="2" fill="#4A5164"/>
            <circle cx="35" cy="35" r="2" fill="#4A5164"/>
            <circle cx="35" cy="88" r="2" fill="#4A5164"/>
            <circle cx="63" cy="24" r="3" transform="rotate(-90 63 24)" fill="#626B84"/>
            <circle cx="24" cy="62" r="3" fill="#626B84"/>
            <circle cx="63" cy="100" r="3" transform="rotate(-90 63 100)" fill="#626B84"/>
            </svg>
            <img className="compassArrow"  alt=""
                src={CompassArrow} 
                // onDrag={moveCompassArrow} 
                // onDragStart={moveCompassStartEnd} 
                // onDragEnd={moveCompassStartEnd}
                draggable="false"
                onClick={moveCompassToPoint}
                style={{transform: `rotate(${rotation}deg)`}}
            />
            <div className="compassLabel">{direction}</div>
        </div>
    )
}

export default Compass;